import MuiTabs from '@mui/material/Tabs';
import { styled } from '@mui/system';
import colors from '../../../assets/colors';

const Tabs = styled(MuiTabs)({
  borderBottom: `1px solid ${colors.oldAgroweGreen}`,
  '.MuiTabs-indicator': {
    backgroundColor: colors.white,
  },
  '.MuiTabs-scrollButtons': {
    color: colors.white,
  },
});

export default Tabs;
